var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Score, Song } from '@ddradar/core';
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { deleteChartScore, getChartScore, postChartScore } from '~/api/score';
import * as popup from '~/utils/popup';
let ScoreEditorComponent = class ScoreEditorComponent extends Vue {
    constructor() {
        super(...arguments);
        this.score = 0;
        this.exScore = 0;
        this.clearLamp = 0;
        this.maxCombo = 0;
        this.isFailed = false;
        this.selectedChart = null;
        this.isLoading = true;
    }
    get rank() {
        return this.isFailed ? 'E' : Score.getDanceLevel(this.score);
    }
    get exScoreMax() {
        /* istanbul ignore if */
        if (!this.selectedChart)
            return 0;
        return ((this.selectedChart.notes +
            this.selectedChart.freezeArrow +
            this.selectedChart.shockArrow) *
            3);
    }
    get chartName() {
        /* istanbul ignore if */
        if (!this.selectedChart)
            return null;
        const playStyle = Song.playStyleMap.get(this.selectedChart.playStyle);
        const difficulty = Song.difficultyMap.get(this.selectedChart.difficulty);
        return `${playStyle}/${difficulty}`;
    }
    get maxComboMax() {
        /* istanbul ignore if */
        if (!this.selectedChart)
            return 0;
        return this.selectedChart.notes + this.selectedChart.shockArrow;
    }
    get charts() {
        return this.songData.charts.map(c => ({
            playStyle: c.playStyle,
            difficulty: c.difficulty,
            label: `${Song.playStyleMap.get(c.playStyle)}/${Song.difficultyMap.get(c.difficulty)}`,
        }));
    }
    async created() {
        var _a;
        if (this.playStyle !== null && this.difficulty !== null) {
            this.selectedChart =
                (_a = this.songData.charts.find(c => c.playStyle === this.playStyle && c.difficulty === this.difficulty)) !== null && _a !== void 0 ? _a : null;
            await this.fetchScore();
        }
    }
    async onChartSelected({ playStyle, difficulty, }) {
        var _a;
        this.selectedChart =
            (_a = this.songData.charts.find(c => c.playStyle === playStyle && c.difficulty === difficulty)) !== null && _a !== void 0 ? _a : null;
        await this.fetchScore();
    }
    calcScore() {
        var _a, _b;
        /* istanbul ignore if */
        if (!this.selectedChart)
            return;
        try {
            const score = Score.setValidScoreFromChart(this.selectedChart, {
                score: this.score,
                exScore: this.exScore,
                maxCombo: this.maxCombo,
                clearLamp: this.clearLamp,
                rank: this.rank,
            });
            this.score = score.score;
            this.exScore = (_a = score.exScore) !== null && _a !== void 0 ? _a : this.exScore;
            this.maxCombo = (_b = score.maxCombo) !== null && _b !== void 0 ? _b : this.maxCombo;
            this.clearLamp = score.clearLamp;
            this.isFailed = score.rank === 'E';
        }
        catch (_c) {
            popup.warning(this.$buefy, this.$t('message.cannotCalc'));
        }
    }
    async saveScore() {
        /* istanbul ignore if */
        if (!this.selectedChart)
            return;
        const playStyle = this.selectedChart.playStyle;
        const difficulty = this.selectedChart.difficulty;
        try {
            await postChartScore(this.$http, this.songId, playStyle, difficulty, {
                score: this.score,
                exScore: this.exScore,
                maxCombo: this.maxCombo,
                clearLamp: this.clearLamp,
                rank: this.rank,
            });
            popup.success(this.$buefy, this.$t('message.successSave'));
        }
        catch (error) {
            popup.danger(this.$buefy, error);
        }
        this.close();
    }
    deleteScore() {
        this.$buefy.dialog.confirm({
            message: this.$t('message.deleteScore'),
            type: 'is-warning',
            hasIcon: true,
            onConfirm: async () => {
                await this.callDeleteAPI();
                this.close();
            },
        });
    }
    async fetchScore() {
        var _a, _b;
        if (!this.selectedChart)
            return;
        this.isLoading = true;
        const playStyle = this.selectedChart.playStyle;
        const difficulty = this.selectedChart.difficulty;
        try {
            const scores = await getChartScore(this.$http, this.songId, playStyle, difficulty, 'private');
            this.score = scores[0].score;
            this.exScore = (_a = scores[0].exScore) !== null && _a !== void 0 ? _a : this.exScore;
            this.clearLamp = scores[0].clearLamp;
            this.maxCombo = (_b = scores[0].maxCombo) !== null && _b !== void 0 ? _b : this.maxCombo;
            this.isFailed = scores[0].rank === 'E';
        }
        catch (error) {
            this.isLoading = false;
            const message = error instanceof Error ? error.message : `${error}`;
            if (message !== '404') {
                popup.danger(this.$buefy, message);
            }
        }
        this.isLoading = false;
    }
    async callDeleteAPI() {
        /* istanbul ignore if */
        if (!this.selectedChart)
            return;
        const playStyle = this.selectedChart.playStyle;
        const difficulty = this.selectedChart.difficulty;
        try {
            await deleteChartScore(this.$http, this.songId, playStyle, difficulty);
            popup.success(this.$buefy, this.$t('message.successDelete'));
        }
        catch (error) {
            popup.danger(this.$buefy, error);
        }
    }
    close() {
        // @ts-ignore
        this.$parent.close();
    }
};
__decorate([
    Prop({ required: true, type: String })
], ScoreEditorComponent.prototype, "songId", void 0);
__decorate([
    Prop({ required: false, type: Number, default: null })
], ScoreEditorComponent.prototype, "playStyle", void 0);
__decorate([
    Prop({ required: false, type: Number, default: null })
], ScoreEditorComponent.prototype, "difficulty", void 0);
__decorate([
    Prop({ required: true, type: Object })
], ScoreEditorComponent.prototype, "songData", void 0);
ScoreEditorComponent = __decorate([
    Component({ fetchOnServer: false })
], ScoreEditorComponent);
export default ScoreEditorComponent;
